import en from './locales/en';
import ch from './locales/ch';

export default {
    en,
    ch
}